import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { Dialog, SharedModule } from "@bb-vendure/admin-ui/core";
import { AssetFileInputComponent } from "../asset-file-input/asset-file-input.component";

@Component({
  standalone: true,
  imports: [SharedModule, AssetFileInputComponent],
  templateUrl: "./import-refund-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImportRefundDialogComponent implements Dialog<any>, OnInit {
  resolveWith: (result?: any) => void;
  fileUpload: File | null = null;
  error: string = "";

  ngOnInit(): void {}

  cancel() {
    this.resolveWith();
  }

  handleFileInput(files: File[]) {
    this.fileUpload = files[0] ?? null;
  }

  import() {
    this.resolveWith(this.fileUpload);
  }
}
